import React from 'react'
import { NumericTextBox } from '@progress/kendo-react-inputs'
import { accentUtils, t, formHelper } from '../../services/HelperService'

export class AccentNumber extends React.Component {

    constructor(props) {
        super(props);

        this.ctrl = React.createRef();
        this.focused = false;

        this.currentUserValue = this.props.model.getValue();

        this.handleBlur = this.handleBlur.bind(this);
        this.handleChange = this.handleChange.bind(this);        
        this.handleFocus = this.handleFocus.bind(this);
        this.isFocused = this.isFocused.bind(this);
        this.clearValue = this.clearValue.bind(this);
    }


    //kendo bug event not working
    handleBlur(e) {
         this.focused = false;
    }

    clearValue() {
        if (!accentUtils.isNull(this.ctrl.current)) {
            // total hack!!!
            this.ctrl.current.value = 0;
            //this.ctrl.current.forceUpdate();
        }
        this.props.model.setValue(0);
        this.forceUpdate();

    }

    handleChange(e) {

        var value = this.ctrl.current.value;

        this.currentUserValue = value;

        this.props.model.setValue(value);

        if (!accentUtils.isNull(this.props.model.options.onChange)) {
            this.props.model.options.onChange();
        }


        this.props.model.modified();
    }

    handleFocus(e) {
        this.focused = true;
    }

    isFocused() {
        if (accentUtils.isNull(this.focused)) {
            this.focused = false;
        }
        return this.focused;
    }



    render() {
        var disabled = formHelper.isControlReadOnly(this.props.model);



        var modelValue = this.props.model.getValue();
        var min = this.props.model.options.min;
        var max = this.props.model.options.max;
        
        return (
            <NumericTextBox ref={this.ctrl} value={modelValue} disabled={disabled} min={min} max={max} label={this.props.model.displayLabel} onBlur={this.handleBlur} onFocus={this.handleFocus} onChange={this.handleChange} defaultValue={this.props.model.getValue()} format="n0" />
        );


    }
}
